import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { GraduationCap } from 'lucide-react'

import { ThemeToggle } from '@/shared/ui/ThemeToggle'
import { BannerStrip } from '@/features/site/BannerStrip'

export function AuthShell({
  title,
  children,
  footer,
}: {
  title: string
  children: ReactNode
  footer: ReactNode
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-bg">
      <header className="border-b border-line">
        <div className="shell flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-semibold text-ink">
            <GraduationCap aria-hidden className="size-5 text-accent" />
            Учусь тут
          </Link>
          <ThemeToggle />
        </div>
      </header>
      <main className="flex flex-1 items-start justify-center px-4 py-10 sm:items-center">
        <div className="w-full max-w-md">
          {/* Объявления нужны и до входа: о технических работах человек
              должен узнать раньше, чем попытается войти (ТЗ §26.31.11). */}
          <BannerStrip placement="login" />
          <h1 className="mt-4 text-2xl font-bold">{title}</h1>
          <div className="surface mt-5 p-5 shadow-raised sm:p-6">{children}</div>
          <p className="mt-5 text-center text-meta text-ink-soft">{footer}</p>
        </div>
      </main>
    </div>
  )
}
